export default "__VITE_ASSET__6c68104f__"